import React from 'react';
import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Transactions',
		url: '/transactions',
		icon: 'shopping-cart',
	}
];

export default class Transactions extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.Transactions
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						reloadParent={this.props.reloadParent}
						account={this.props.account}
					/>
				</Framework.Errors.General>
			</div>

		);
	}
}


